import React from "react";

interface ShowcaseInputProps {
  label: string;
  value: string;
}

const ShowcaseInput = ({ label, value }: ShowcaseInputProps) => {
  return (
    <div>
      <label className="block text-sm font-normal text-natural-grey-400 mb-2">
        {label}
      </label>
      <input
        className="w-full rounded-md ring-1 ring-natural-grey-200 py-2 px-4"
        value={value}
        disabled
      />
    </div>
  );
};

export default ShowcaseInput;
